// extracted by mini-css-extract-plugin
module.exports = {"what-is-tenderwolf-button":"whatIsTenderwolfButton_what-is-tenderwolf-button__1fZVC"};